// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/QRCodeBox/qr-code-box.scss
// module id = 74
// module chunks = 0